import React from 'react';
import cx from 'classnames';

import { YellowButton } from '@marketing/components/buttons';
import UnderlinedText from '@marketing/components/underlined_text';

import CreateAssignmentScreen from './assets/create_assignment_screen.png';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div
      className={marketingStyles.purpleNoiseBg}
      style={{
        borderRadius: 20,
        boxShadow: '0 6px 6px -3px rgba(0, 0, 0, 0.07), 0 2px 2px -1px rgba(0, 0, 0, 0.07)',
        overflow: 'hidden'
      }}
    >
      <div className="d-flex flex-column flex-lg-row">
        <div className="align-items-center align-items-lg-start d-flex flex-column gap-l u-padding-A-xl">
          <div>
            <h2
              className={cx(styles.centeredOnMobile, 'u-margin-A-n')}
              style={{ color: '#FCB913', fontSize: 40 }}
            >
              <strong>Educators</strong>
            </h2>

            <h2
              className={cx(styles.centeredOnMobile, 'u-margin-A-n')}
              style={{ color: '#FFFFFF', fontSize: 40 }}
            >
              <strong>+ Magoosh</strong>
            </h2>
          </div>

          <div className={styles.centeredOnMobile} style={{ color: '#FFFFFF', fontSize: 15 }}>
            Find out how Magoosh can help your school <UnderlinedText color="#ffffff">improve test scores</UnderlinedText> today!
          </div>

          <div>
            <YellowButton href="https://schools.magoosh.com/?utm_source=sat-homepage&utm_medium=midpage&utm_campaign=highschool">
              Become a Partner School
            </YellowButton>
          </div>
        </div>

        <div
          className={cx(styles.createAssignmentScreenContainer, 'd-flex align-items-end')}
          style={{ position: 'relative' }}
        >
          <img
            alt="Screenshot of official questions in Magoosh"
            className={styles.createAssignmentScreen}
            loading="lazy"
            src={CreateAssignmentScreen}
          />
        </div>
      </div>
    </div>
  );
};
